import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
// material
import { CssBaseline } from '@mui/material';
import { ThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
//
import shape from './shape';
import palette from './palette';
import components from './components';
import typography from './typography';
import componentsOverride from './overrides';
import shadows, { customShadows } from './shadows';
import * as locales from '@mui/material/locale';
import {  deDE as dg }  from '@mui/x-data-grid';

import {  useTranslation } from 'react-i18next';

import { LangProvider } from '../components/common/LangContext';
// ----------------------------------------------------------------------

ThemeConfig.propTypes = {
  children: PropTypes.node
};

export default function ThemeConfig({ children }) {


  const themeOptions = useMemo(
    () => ({
      palette,
      shape,
      typography,
      shadows,
      customShadows,
      components
    }),
    []
  );

  const {t, i18n} = useTranslation();



  var theme = null;
  if (i18n.language == "de"){
    theme = createTheme(themeOptions, locales["deDE"], dg );
  }
  else{
    theme = createTheme(themeOptions);
  }

  //theme.components = componentsOverride(theme);

 const [lang, setLang] = React.useState(i18n.language);

      
  React.useEffect(() => {
    setLang(i18n.language);
  });
  
  return (
    <LangProvider value={{ lang, setLang }}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider  theme={theme}>
          <CssBaseline />
          {children}
        </ThemeProvider>
      </StyledEngineProvider>   
    </LangProvider>
  );
}
